import React, { useEffect, useState } from 'react';
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";

const SearchInput = (props) => {
    let [text, setText] = useState(props.value);
    let [timer, setTimer] = useState();

    useEffect(() => {
        setText(props.value);
    }, [props.value]);

    const handleChange = (searchText) => {
        setText(searchText);
        clearTimeout(timer);
        setTimer(
            setTimeout(() => {
                props.onChange(searchText)
            },
            1000
        ));
    };

    const handleClear = () => {
        setText('');
        props.onChange('');
    }

    return (
        <TextField
            className="margin-0 clearable-input"
            id="searchTerm"
            placeholder="Search"
            value={text}
            onChange={(e) => handleChange(e.target.value)}
            InputLabelProps={{shrink: true}}
            InputProps={{
                endAdornment:
                    <InputAdornment position="end">
                        {text && (
                            <IconButton onClick={(e) => { handleChange(''); }} edge="end" size="large">
                                <i className="fa fa-close fa-thin"/>
                            </IconButton>
                        )}
                    </InputAdornment>,
            }}
        />
    );

    /*
     * @7ODO: Clear button
     * @url - https://locale-uk.atlassian.net/browse/LPD-2844
     */
}

export default SearchInput;
